import * as StarmanIcon from '@gbm/starman-next/icon';

import { type ComboboxModelModel } from '../combobox-model';

const MODEL: ComboboxModelModel = [];

for (const key in StarmanIcon) {
  const Icon = StarmanIcon[key as keyof typeof StarmanIcon];
  MODEL.push({
    value: key,
    item: (
      <div className="flex items-center gap-4">
        <Icon />
        {key}
      </div>
    ),
  });
}

export function getStarmanIcons() {
  return MODEL;
}
